/**
 * @generated SignedSource<<fc7a5b39dc58a6e08a0bf3eba0717dbd>>
 * @relayHash 44e0520fbe7c9312855d33dc878efa15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e05a59679b028a14828cd049a892942950bfcc88e314b92df19350712d643be4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type approverSelector_Query$variables = {
  excludedAccountIds?: ReadonlyArray<string> | null | undefined;
  searchText?: string | null | undefined;
  versionAri: string;
};
export type approverSelector_Query$data = {
  readonly jira: {
    readonly version: {
      readonly project?: {
        readonly suggestedApproversForJiraVersion: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly accountId: string;
              readonly extendedProfile?: {
                readonly jobTitle: string | null | undefined;
              } | null | undefined;
              readonly name: string;
              readonly picture: AGG$URL;
            };
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
    };
  };
};
export type approverSelector_Query = {
  response: approverSelector_Query$data;
  variables: approverSelector_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludedAccountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchText"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "excludedAccountIds",
    "variableName": "excludedAccountIds"
  },
  {
    "kind": "Variable",
    "name": "searchText",
    "variableName": "searchText"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "picture"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianAccountUserExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ],
  "type": "AtlassianAccountUser"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "approverSelector_Query",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraProject",
                          "kind": "LinkedField",
                          "name": "project",
                          "plural": false,
                          "selections": [
                            {
                              "args": (v4/*: any*/),
                              "concreteType": "JiraVersionSuggestedApproverConnection",
                              "kind": "LinkedField",
                              "name": "suggestedApproversForJiraVersion",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraVersionSuggestedApproverEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": (v5/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.version.project.suggestedApproversForJiraVersion.edges.node.accountId"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v6/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.version.project.suggestedApproversForJiraVersion.edges.node.name"
                                          },
                                          (v7/*: any*/),
                                          (v8/*: any*/)
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "jira.version.project.suggestedApproversForJiraVersion.edges.node"
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.version.project"
                      }
                    ],
                    "type": "JiraVersion"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.version"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "approverSelector_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v4/*: any*/),
                        "concreteType": "JiraVersionSuggestedApproverConnection",
                        "kind": "LinkedField",
                        "name": "suggestedApproversForJiraVersion",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraVersionSuggestedApproverEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v10/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v10/*: any*/)
                    ]
                  }
                ],
                "type": "JiraVersion"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e05a59679b028a14828cd049a892942950bfcc88e314b92df19350712d643be4",
    "metadata": {},
    "name": "approverSelector_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ecf6916313ab62b01f6ac39409f8349e";

export default node;
